import React, {useEffect, useState} from 'react';
import PulsoidClient from '../../PulsoidClient';
import {MenuItemContainer} from '../../system/menu';
import {AutomatedClips} from './AutomatedClips';
import {General} from './General';
import {BROPlan} from './BROPlan';
import {Premium} from '../dashboard/Premium';

const client = new PulsoidClient();

export const ProfileSettings = ({}) => {
  const [profile, setProfile] = useState(null);

  const refreshState = async () => {
    let profile = await client.getUserInfo();
    setProfile(profile);
  };

  useEffect(() => {
    refreshState();
  }, []);

  return (
    <MenuItemContainer title={'Profile settings'}>
      <h1>Profile Settings</h1>
      <hr />
      <General profile={profile} refresh={refreshState} />
      <AutomatedClips profile={profile} />
      <BROPlan />
    </MenuItemContainer>
  );
};
